import axios from 'axios';

export type PaymentMethodOption = {
  id: number;
  name: string;
};

export class PaymentMethodApi {
  static readonly KEY = 'paymentMethod';

  static async getPaymentMethods(terminalId?: string): Promise<PaymentMethodOption[]> {
    const { data } = await axios.get('/api/v1/paymentMethod', {
      params: !!terminalId ? { terminalId } : undefined,
    });

    return data.data;
  }
}
